import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=283e272e&scoped=true&"
import script from "./SettingsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=283e272e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e272e",
  null
  
)

export default component.exports